/**
 * Passthrough. O hard-lock antigo redirecionava qualquer aluno B2C novo sem
 * assinatura paga para `/planos`. A nova regra é: o aluno pode acessar
 * qualquer módulo ativo do tenant, com cota gratuita (5 questões/dia +
 * 4 simulados/mês). O gating agora acontece dentro de cada feature via
 * `useFreeTrialGate` + `UpgradeWall`, e não mais por redirect global.
 *
 * Mantido como componente para não quebrar o import em `ProtectedRoute.tsx`.
 */
interface FreemiumGuardProps {
  children: React.ReactNode;
}

export function FreemiumGuard({ children }: FreemiumGuardProps) {
  return <>{children}</>;
}
